import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { IoFingerPrintSharp, IoEye, IoEyeOff } from 'react-icons/io5';
import { AuthContext } from '../../context/AuthContext';
import Toast from '../../components/Toast';
import SummaryApi from '../../common';

const Login = () => {
  const [formData, setFormData] = useState({ loginId: '', password: '' });
  const [toast, setToast] = useState({ show: false, message: '', type: '' });
  const [showPassword, setShowPassword] = useState(false);
  const { isLoggedIn, login } = useContext(AuthContext);
  const navigate = useNavigate();
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  // Redirect to /dashboard if already logged in
  useEffect(() => {
    if (isLoggedIn) {
      navigate('/dashboard');
    }
  }, [isLoggedIn, navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios({
        method: 'POST',
        url: `${BACKEND_URL}/api/auth/login`,
        data: formData,
      });
      if (res.data.token) {
        login(res.data.token, {
          userId: res.data.user.userId,
          firstName: res.data.user.firstName,
          userType: res.data.user.userType,
          companyId: res.data.user.companyId, // Add companyId
        }); // Update AuthContext with token and user data
        setToast({ show: true, message: 'Login successful', type: 'success' });
        setTimeout(() => navigate('/dashboard'), 2000);
      }
    } catch (err) {
      setToast({
        show: true,
        message: err.response?.data?.message || 'Login failed',
        type: 'error',
      });
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-teal-900 to-blue-950 px-4 sm:px-6 lg:px-8">
      <div className="text-center w-full max-w-md mx-auto">
        <div className="mb-6">
          <div className="w-12 h-12 mx-auto bg-gray-300 rounded-full flex items-center justify-center">
            <IoFingerPrintSharp className="h-10 w-10 font-teal-500" />
          </div>
          <h2 className="text-2xl font-bold text-white mt-4">Login to Your Account</h2>
          <p className="text-gray-300">Access your dashboard</p>
        </div>
        <form onSubmit={handleSubmit} className="w-full">
          <div className="mb-4">
            <input
              type="text"
              name="loginId"
              value={formData.loginId}
              onChange={handleChange}
              placeholder="Email or Login ID"
              className="w-full p-3 bg-transparent border border-gray-500 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
          <div className="mb-4 relative">
            <input
              type={showPassword ? 'text' : 'password'}
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Password"
              className="w-full p-3 bg-transparent border border-gray-500 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 pr-10"
              required
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400"
            >
              {showPassword ? <IoEyeOff className="w-5 h-5" /> : <IoEye className="w-5 h-5" />}
            </button>
          </div>
          <div className="flex justify-between items-center mb-6 text-sm text-gray-300">
            <label className="flex items-center">
              <input type="checkbox" className="mr-2" />
              Remember me
            </label>
            <a href="/forgot-password" className="text-gray-300 hover:underline">
              Forgot password
            </a>
          </div>
          <button
            type="submit"
            className="w-full bg-white text-gray-800 font-semibold p-3 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
          >
            Login
          </button>
        </form>
        
        {toast.show && (
          <Toast
            message={toast.message}
            type={toast.type}
            onClose={() => setToast({ show: false, message: '', type: '' })}
          />
        )}
      </div>
    </div>
  );
};

export default Login;